import { ACTIONS } from '../Constants';

const initialState = {
    byId: {}
};

const learningFrameworks = (state = initialState, action) => {
    let newById;
    let reduced;

    switch (action.type) {
        case ACTIONS.GET_MANY_LEARNING_FRAMEWORKS: {
            const { learningFrameworks = [] } = action.payload;

            reduced = learningFrameworks.reduce((prev, behavior) => {
                prev[behavior._id] = behavior;
                return prev;
            }, {});
            newById = {
                ...state.byId,
                ...reduced
            };
            return {
                ...state,
                byId: newById
            };
        }
        case ACTIONS.GET_LEARNING_FRAMEWORK:
        case ACTIONS.PUT_LEARNING_FRAMEWORK_SUCCESS:
        case ACTIONS.POST_LEARNING_FRAMEWORK_SUCCESS: {
            const { learningFramework } = action.payload;
            newById = {
                ...state.byId,
                [learningFramework._id]: learningFramework
            };
            return {
                ...state,
                byId: newById
            };
        }

        default:
            return state;
    }
};

export default learningFrameworks;
